// extracted by mini-css-extract-plugin
export var contrastLow = "_s-1";
export var externalLink = "_s-2";
export var externalLinkIcon = "_s-3";
export var link = "_s-0";
export var linkLabel = "_s-4";